import { render, staticRenderFns } from "./OuterView.vue?vue&type=template&id=f47ac706"
import script from "./OuterView.vue?vue&type=script&lang=js"
export * from "./OuterView.vue?vue&type=script&lang=js"
import style0 from "./OuterView.vue?vue&type=style&index=0&id=f47ac706&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports